export const Check = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.70711 5.2929C1.31658 4.90238 0.683418 4.90238 0.292893 5.2929C-0.0976311 5.68343 -0.0976311 6.31659 0.292893 6.70712L5.29289 11.7071C5.69802 12.1122 6.36002 12.0948 6.74329 11.669L15.7433 1.66897C16.1128 1.25846 16.0795 0.626173 15.669 0.256714C15.2585 -0.112745 14.6262 -0.0794662 14.2567 0.331044L5.96181 9.5476L1.70711 5.2929Z"
      fill="currentColor"
    />
  </svg>
);
